"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.decisionStatusTranslation = exports.DecisionStatus = void 0;
var DecisionStatus;
(function (DecisionStatus) {
    DecisionStatus["NOT_TREATED"] = "notTreated";
    DecisionStatus["TO_KEEP"] = "toKeep";
    DecisionStatus["TREATED"] = "treated";
})(DecisionStatus || (exports.DecisionStatus = DecisionStatus = {}));
exports.decisionStatusTranslation = (_a = {},
    _a[DecisionStatus.TO_KEEP] = 'À conserver',
    _a[DecisionStatus.NOT_TREATED] = 'À traiter',
    _a[DecisionStatus.TREATED] = 'Traitée',
    _a);
//# sourceMappingURL=decisions.js.map